module.exports = __webpack_public_path__ + "img/block1Img06.79aedad8.png";